<template>
  <div id="cause" class="fixed-content">
    <page-section :header="require('@/assets/meeting.jpg')"
                title="L'analyse des causes 2026">
      <div class="row feature-block-row">
        <div class="col-md-3" />
        <feature-block v-for="(b, k) in texts.causeAnalysis"
                       class="col-md-2 col-sm-4 col-xs-6"
                       :key="k" :title="b.title" :subtitle="b.subtitle"
                       :text="b.text" :icon="b.icon">
        </feature-block>
      </div>
    </page-section>

    <page-section type="dark-base" title="En pratique">
      <div class="row">
        <div class="col-md-6 col-md-offset-3 col-sm-offset-2 col-sm-8">
          <div class="panel panel-badiCause">
            <div class="panel-heading text-center">
              <h2 class="panel-title">
                <strong>BADICAUSE</strong>
              </h2>
              <h4>
                Analyse des causes d'une bactériémie liée à un cathéter
              </h4>
            </div>
            <div class="panel-body">
              <ul>
                <span v-for="(b, k) in texts.badiCause" :key="`hfb-${k}`">
                  <horizontal-feature-block :title="b.title"
                                            :texts="b.texts" class="hfb-badiCause"
                                            :icon="b.icon">
                  </horizontal-feature-block>
                  <div class="row">
                    <div v-if="b.separator">
                      <div class="col-xs-3 text-center">
                        <span class="glyphicon txt-badiCause"
                              :class="`glyphicon-${b.separator.icon}`"
                              :style="b.separator.style">
                        </span>
                      </div>
                      <div class="col-xs-9">
                        <hr class="border-badiCause" v-if="b.separator.hr">
                      </div>
                    </div>
                  </div>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </page-section>
    <page-section title="Téléchargements">
      <div class="row">
        <div class="col-md-4 col-md-offset-0 col-sm-offset-2 col-sm-8">
          <div class="panel panel-badiCause">
            <div class="panel-heading text-center">
              <h2 class="panel-title"><strong>BADICAUSE</strong></h2>
            </div>
            <div class="panel-body">
              <ul>
                <span v-for="(b, k) in files.badiCause"
                      :key="k">
                  <div class="col-xs-12">
                    <link-block :file="b.file"
                              :link="b.link"
                              :description="b.description"
                              :title="b.title"
                              class="fb-badiCause"
                              :text="b.text"
                              :icon="b.icon">
                    </link-block>
                  </div>
                </span>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-md-offset-0 col-sm-offset-2 col-sm-8">
          <div class="panel panel-gray">
            <div class="panel-heading text-center">
              <h2 class="panel-title"><strong>Annexes</strong></h2>
            </div>
            <div class="panel-body">
              <ul>
                <div v-for="(b, k) in files.causeAnnexes"
                     :key="k">
                  <div class="col-xs-12 col-md-6">
                    <link-block :link="b.link"
                                :description="b.description"
                                :title="b.title"
                                class="fb-gray"
                                :text="b.text"
                                :icon="b.icon">
                    </link-block>
                  </div>
                  <div v-if="!((k + 1) % 2)" class="clearfix"></div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </page-section>
  </div>
</template>

<script>
import pageSection from '@/components/pagesection'
import featureBlock from '@/components/featureBlock'
import horizontalFeatureBlock from '@/components/horizontalFeatureBlock'
import linkBlock from '@/components/linkBlock'

import sc from '@/sc/presentation'

export default {
  name: 'observation',

  data () {
    return {
    }
  },

  computed: {
    texts: function () {
      return sc.texts
    },

    files: function () {
      return sc.files
    }
  },

  components: {
    'feature-block': featureBlock,
    'link-block': linkBlock,
    pageSection,
    'horizontal-feature-block': horizontalFeatureBlock
  },

  methods: {
    add () {
      this.$router.push('establishments')
    }
  }
}
</script>

<style scoped lang="less">
@import '~variables';
@import '~modules';

.feature-block-row {
    @media (min-width: @screen-sm-min) and (max-width: @screen-sm-max){
        .col-sm-4:nth-child(4n+1) {
            clear: both;
        }
    }
}

.feature-block {
    margin-bottom: 10rem;
}

ul {
    padding-left: 1rem;
    padding-right: 1rem;
}

h2.panel-title {
    font-size: 180%;
}

</style>
